// extracted by mini-css-extract-plugin
module.exports = {"collapsibleBody":"tINPSxvt","expandedEnterDone":"_34GRfHtn","expandedExit":"_38M8s-gH","expandedEnter":"Cl-h9jjM","toggleButton":"_5L_X1kkQ"};